/* @flow */
// typecheck: ignore file
import React from 'react';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import Text from 'components/Text.jsx';
import Link from 'components/Link.jsx';
import Button from 'components/Button.jsx';
import RemindAPI from 'lib/RemindAPI';
import { showToast, showAPIErrorToast } from 'reducers/toasts';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import isAPIError from 'lib/isAPIError';

import './styles/AdminBillingBanner.scss';

type Props = {
  organizationId: number,
  organization?: { paid: boolean, type: string },
  showToast: (text: string, kind: 'success' | 'error') => any,
  showAPIErrorToast: (error: any) => any,
}

class _AdminBillingBanner extends React.Component {
  props: Props;

  promotion = () => (async () => {
    try {
      await RemindAPI.request(`/organizations/${this.props.organizationId}/get_admin_console_promo`, 'post');
      this.props.showToast('Your request has been sent! We‘ll be in touch', 'success');
    } catch (error) {
      if (!isAPIError(error)) { throw error; }

      if (error && error.code === 'throttling_error') {
        this.props.showToast('Your request has been sent! We‘ll be in touch', 'success');
      } else {
        this.props.showAPIErrorToast(error);
      }
    }
  })()

  render() {
    if (!this.props.organization || this.props.organization.paid) {
      return null;
    }

    return (
      <div className="AdminBillingBanner">
        <div className="AdminBillingBanner-content">
          <Text element="div" size="xlarge">Manage your community and gain powerful insight.</Text>
          <Text element="div" size="large">
            The Admin Console is a premium feature for connected schools and districts.
            Click below to learn more.
          </Text>
          <Text>
            <Link onClick={this.promotion}>
              <Button inline color="white">
                Get the Admin Console
              </Button>
            </Link>
          </Text>
          <Link to="/classes" color="white" target="_blank">Go to Remind</Link>
        </div>
      </div>
    );
  }
}

const withOrganization = graphql(gql`
  query($organizationId: Int) {
    organizations(ids: [$organizationId]) {
      id
      paid
      type
    }
  }`,
  {
    options: ({ organizationId }) => ({ variables: { organizationId: [organizationId] } }),
    props: ({ data }) => ({ organization: data.organizations ? data.organizations[0] : null }),
  }
);

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ showToast, showAPIErrorToast }, dispatch);
}

const AdminBillingBanner = connect(undefined, mapDispatchToProps)(withOrganization(_AdminBillingBanner));

function AdminBillingBannerWrapper(_props: any, context: any) {
  const { router } = context;
  const { schoolId, districtId } = router.params;

  return <AdminBillingBanner organizationId={Number(schoolId || districtId)} />;
}

AdminBillingBannerWrapper.contextTypes = {
  router: React.PropTypes.object.isRequired,
};

export { _AdminBillingBanner as AdminBillingBanner };
export default AdminBillingBannerWrapper;



// WEBPACK FOOTER //
// ./src/admin/components/AdminBillingBanner.jsx